import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FilterFramesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_frames"}/>
}
